module.exports = __webpack_public_path__ + "img/activity_2_vid_1_splash.68989661.jpg";